// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo___1xovT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Logo/Logo.scss
// module id = 1350
// module chunks = 0